var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass:
            "battery-order-view__container battery-order-view__container--form"
        },
        [
          _c(
            "div",
            {
              staticClass:
                "battery-order-view__row battery-order-view__row--title"
            },
            [_vm._v("\n      Add Items\n    ")]
          ),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c("ProductForm")
        ],
        1
      ),
      _vm._v(" "),
      _c("ProductCartView"),
      _vm._v(" "),
      _vm.hasPowerOne && !_vm.meetsCartonMinimum
        ? _c(
            "div",
            {
              staticClass:
                "battery-store__unmet-minimum h-helper-text h-center-align"
            },
            [
              _vm._v(
                "There is a 10 carton minimum purchase requirement for Power One orders"
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "battery-store__nav-row h-center-align" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-primary",
            attrs: { disabled: !_vm.isOrderValid },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.nextStep($event)
              }
            }
          },
          [_vm._v("Add Shipping Info")]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "battery-order-view__row battery-order-view__row--imprint"
      },
      [
        _c("p", [
          _vm._v(
            "Add imprinting to your battery cards with your logo and/or text."
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "If this is your first time ordering or you would like to update your imprint, select "
          ),
          _c("strong", [_vm._v("New Imprint")]),
          _vm._v(". We will contact you to get your new imprint setup.")
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "If you already have imprinting and would like to order more batteries, select "
          ),
          _c("strong", [_vm._v("Current Imprint")]),
          _vm._v(".")
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v("If you don’t want imprinting on your battery cards, select "),
          _c("strong", [_vm._v("No Imprint")]),
          _vm._v(".")
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }